import { FormControl, InputLabel, Select } from "@mui/material";

export const DefaultDropdown = ({value, setValue, options, label, labelId, disabled, formProps, selectProps}) => {

  const handleChange = (e, info) => {
    setValue(info.props.value);
  }

  return (
    <FormControl
      size="small"
      variant="outlined"
      className={`width-100`}
      disabled={disabled}
      {...formProps}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        sx={{height: '34px !important'}}
        {...selectProps}
        className="width-100"
        size="small"
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
            },
          },
        }}
        labelId={labelId}
        value={value}
        label={label}
        onChange={handleChange}
        disabled={disabled}
      >
        {options}
      </Select>
    </FormControl>
  )
}